import React from 'react';
import classNames from 'classnames';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import ResourceSummaryCard from 'Components/ComponentLibrary/Components/Uncategorized/ResourceSummaryCard';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import WizardStandardHeader from 'Components/ComponentLibrary/Components/Uncategorized/WizardStandardHeader';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { wizardClasses } from 'Views/Page/Content/Templates/WizardTemplates/wizardCommonStyles';
import useApexFundingAccountSync from './useApexFundingAccountSync';


const useStyles = makeStyles(theme => ({
  root: {
    ...wizardClasses.root(theme),
    margin: 0,
    height: '100vh',
  },
  container: {
    ...wizardClasses.container(theme),
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(3),
  },
  subtitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(3.5),
  },
}));

const ApexFundingAccountSyncTemplate = ({ className }) => {
  const history = useHistory();
  const onClose = async () => {
    history.push('/');
  };

  const {
    pageContentResource: resource,
    refreshPageContentCollection,
    setPageContentCollection,
  } = usePageContentContext();

  async function loadNextStep() {
    // navigate to the next step
    const collection = await resource.submit();
    setPageContentCollection(collection);
  }

  useApexFundingAccountSync(resource, refreshPageContentCollection, loadNextStep);

  const classes = useStyles();

  return (
    <Box className={classNames(classes.root, className)}>
      <WizardStandardHeader
        color={'primary'}
        title={resource.attr('moduleName')}
        onClose={onClose}
      />
      <Box className={classes.container}>
        <Title className={classes.title} text={resource.attr('title')} test={'wizard-step-title'} />
        <Subtitle className={classes.subtitle} text={resource.attr('subtitle')} test={'wizard-step-subtitle'} />
        <ResourceSummaryCard resource={resource.attr('account').resources().head()} />
        <LoadingIndicator />
      </Box>
    </Box>
  );
};
ApexFundingAccountSyncTemplate.defaultProps = {
  className: '',
};
ApexFundingAccountSyncTemplate.propTypes = {
  className: PropTypes.string,
};

export default ApexFundingAccountSyncTemplate;
